import to from "@/lib/to";

export default {
  namespaced: true,
  state: {
    scores: {}
  },
  mutations: {
    setScores(state, scores) {
      state.scores = scores;
    }
  },
  getters: {
    getAcuityScore: (state) => (monitorId) => {
      return state.scores[monitorId];
    }
  },
  actions: {
    async fetchAcuityScores({ commit }, monitorIds) {
      const [err, response] = await to(this.$http.get('/patient_monitors/acuity_scores', { skipLoading: true, params: { monitor_ids: monitorIds.join(',') } }));
      if (!err) {
        commit('setScores', response.data);
      }
    }
  },
}